export default __webpack_public_path__ + "static/media/SLIDE_HENRIQUEZ_1.30ccb275.jpg";